
'use client'

import React, { useEffect, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './styles.css';

// import required modules
import { Pagination } from 'swiper/modules';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'



const Barbar = () => {
    const [data, setData] = useState([])
    const [, setLoader] = useState(true)

    useEffect(() => {
        setLoader(true)
        axios
            .get("https://api.kazbarber.com/api/barbers")
            .then((response) => {
                setLoader(false)
                console.log(response.data, 'data1');
                setData(response.data);
            })
            .catch((error) => {
                setLoader(false)
                console.error('Error fetching barber data:', error);
            });
    }, []);
    // const response = await  getbarber();
    console.log(data, "data11")
    return (
        <>
            <section id="ourbarbar" class="our-team">
                <div class="container">
                    <div class="row">
                        <h2 class="heading-title">Our Barbar</h2>
                        <Swiper
                            slidesPerView={3}
                            spaceBetween={30}
                            pagination={{
                                clickable: true,
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 40,
                                },
                            }}
                            modules={[Pagination]}
                            className="mySwiper"
                        >
                            <div class="our-team-wrapper clearfix">
                                {data?.data?.map((e) => {
                                    return (
                                        <>
                                            <SwiperSlide class="swiper-slide p-2">
                                                <Link to={`/detail/${e?.id}`}>
                                                    <div class="our-team-inner">
                                                        <div class="our-team-img">
                                                            <img src={e?.image} alt="" />
                                                        </div>
                                                        <div class="our-team-text">
                                                            <h5>{`${e?.fname} ${e?.lname}` || <Skeleton />}</h5>
                                                            <span>Barber</span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </>
                                    )
                                })}

                            </div>
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Barbar

